export const EMAIL_FEATURES = [
    'Emails automation using APIs and SMTP',
    'Send manually via Google Spreadsheet, or launch campaign directly',
    '99.99% Guaranteed Uptime SLA',
    'Reports tracking and analytics',
    'Support webhook',
    'Supports TXT, MX, CNAME and DMARC',
    'Suppression Management',
];

export const WHATSAPP_FEATURES = [
    'One API for WhatsApp',
    'Send alerts & notifications',
    'WhatsApp Business API',
    'Secure communication',
    'Send strategic business messages',
];

// export const SEGMENTO_FEATURES = [
//     'Run targeted campaigns',
//     'Personalise marketing content',
//     'Automatically segment distinct customer groups',
//     'Subdivide and send relevant user content',
//     'Filter out inactive customers',
//     'Access only the needed data',
// ];

export const SHORT_URL_FEATURES = [
    'Customised Branded Links',
    'Optimise messages',
    'Better message delivery',
    'Short custom messages',
    'Tracking and Reporting',
];

export const NUMBER_FEATURES = [
    'Keyword specific messaging',
    'Keyword independent messaging',
    'Pre-formatted set of questions',
    'Online surveys',
    'Lead generation',
    'Create auto responses',
    'Integration into web application',
    'Real-time feedback on online surveys',
];
